import { render } from "./DashboarOrg.vue?vue&type=template&id=0d5cd8ef&scoped=true"
import script from "./DashboarOrg.vue?vue&type=script&lang=js"
export * from "./DashboarOrg.vue?vue&type=script&lang=js"

import "./DashboarOrg.vue?vue&type=style&index=0&id=0d5cd8ef&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d5cd8ef"]])

export default __exports__